/* eslint-disable no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";
import {
  getAllDispatchOrderDataLoading,
  getAllItemsByProjectId,
  getDispatchOrderByIdAction,
  getDispatchOrderRemarksData,
  addNewDispatchOrder,
  saveNewLaodInData,
  getAllDispatchOrderData,
} from "src/thunks/dispatchOrder";

const initialState = {
  loading: false,
  dispatchOrderLoadingState: false,
  getByIdDispatchOrderLoadingState: false,
  addNewDispatchOrderLoadingState: false,
  addNewVehicleLoadingState: false,
  allDispatchOrderData: [],
  allItemsByDepotId: [],
  getIndividualDispatchOrderData: {},
  remarks: [],
};

const dispatchOrderSlice = createSlice({
  name: "dispatchOrderSlice",
  reducers: {
    clearDepotsDropdown: (state, action) => {
      state.allItemsByDepotId = [];
    },
  },
  initialState,

  extraReducers: (builder) => {
    builder

      // get all dispatch data
      .addCase(getAllDispatchOrderData.pending, (state, action) => {
        state.dispatchOrderLoadingState = true;
      })
      .addCase(getAllDispatchOrderData.fulfilled, (state, action) => {
        state.dispatchOrderLoadingState = false;
        state.allDispatchOrderData = action.payload;
      })
      .addCase(getAllDispatchOrderData.rejected, (state, action) => {
        state.dispatchOrderLoadingState = false;
      })
      // get all dispatch data
      .addCase(getAllDispatchOrderDataLoading.pending, (state, action) => { })
      .addCase(getAllDispatchOrderDataLoading.fulfilled, (state, action) => {
        state.allDispatchOrderData = [
          ...state.allDispatchOrderData,
          ...action?.payload,
        ];
      })
      .addCase(getAllDispatchOrderDataLoading.rejected, (state, action) => { })

      // Get all items by depot id
      .addCase(getAllItemsByProjectId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllItemsByProjectId.fulfilled, (state, action) => {
        state.loading = false;
        let apiData = [...action.payload];
        apiData = apiData.map((depot) => {
          let newDepot = { ...depot };
          newDepot.items = newDepot.items.map((item) => {
            return {
              ...item,
              availableQty: item.currentQuantity - item.onHoldQuantity,
            };
          });
          return newDepot;
        });
        state.allItemsByDepotId = apiData;
      })
      .addCase(getAllItemsByProjectId.rejected, (state, action) => {
        state.loading = false;
      })

      // get dispatch order by id
      .addCase(getDispatchOrderByIdAction.pending, (state, action) => {
        state.getByIdDispatchOrderLoadingState = true;
        state.getIndividualDispatchOrderData = {};
      })
      .addCase(getDispatchOrderByIdAction.fulfilled, (state, action) => {
        state.getByIdDispatchOrderLoadingState = false;
        state.getIndividualDispatchOrderData = action?.payload ?? {};
      })
      .addCase(getDispatchOrderByIdAction.rejected, (state, action) => {
        state.getByIdDispatchOrderLoadingState = false;
      })

      // add new dispatch order
      .addCase(addNewDispatchOrder.pending, (state, action) => {
        state.addNewDispatchOrderLoadingState = true;
      })
      .addCase(addNewDispatchOrder.fulfilled, (state, action) => {
        state.addNewDispatchOrderLoadingState = false;
      })
      .addCase(addNewDispatchOrder.rejected, (state, action) => {
        state.addNewDispatchOrderLoadingState = false;
      })

      // Save new load in data
      .addCase(saveNewLaodInData.pending, (state, action) => {
        state.addNewVehicleLoadingState = true;
      })
      .addCase(saveNewLaodInData.fulfilled, (state, action) => {
        state.addNewVehicleLoadingState = false;
      })
      .addCase(saveNewLaodInData.rejected, (state, action) => {
        state.addNewVehicleLoadingState = false;
      });


  },
});

export default dispatchOrderSlice;

export const { clearDepotsDropdown } = dispatchOrderSlice.actions;
